import classNames from 'classnames';
import React from 'react';

import { regularPrice, salePrice } from '@/src/assets/constants/constants';

import styles from './SaleUnion.module.scss';

type TSaleUnion = {
    color: 'highlight' | 'base';
    className?: string;
};
const SaleUnion: React.FC<TSaleUnion> = ({ color, className }) => {
    return (
        <span className={classNames(styles.union, styles[`union__${color}`], className)}>
            {salePrice}
            <span className={styles.union__regular}>{regularPrice}</span>
        </span>
    );
};

export default SaleUnion;
